import defaultCTATranslations from '@trans/en/cta.json';
function appendNamespace(key) {
    return `cta:${key}`;
}
/**
 * Get CTA translation by key.
 *
 * Note: CTA translations are kept in OneSky "Shared" project only and are
 * not extracted from codebase like other type of translations. To add support
 * for new CTA, add it to "Shared" project manually via OneSky.
 *
 * Note: For default language (en), `t` function returns key without loading i18n libs.
 * CTA's translations are stored with "cta_key" as a translation string key therefor we
 * need to compare key t!=t(key) to see if translation was successful.
 */
export function getCTATranslation(t, key) {
    /* i18next-extract-disable-next-line */
    const translation = t(appendNamespace(key));
    const defaultTranslation = defaultCTATranslations[key];
    return translation !== key
        ? translation
        : defaultTranslation
            ? defaultTranslation
            : key;
}
